import { render, staticRenderFns } from "./students-send.vue?vue&type=template&id=1fac7285&"
import script from "./students-send.vue?vue&type=script&lang=js&"
export * from "./students-send.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports